document.addEventListener('DOMContentLoaded', () => {

  const form = document.querySelector('.lw-newsletter__form');

  if (!form) return;

  const input = form.querySelector('.lw-newsletter-form__input');
  const button = form.querySelector('.lw-newsletter-form__button');
  const message = form.querySelector('.lw-newsletter-form__message');

  function clearValidation() {
    input.classList.remove('is-invalid');
    message.hidden = true;
    message.classList.remove('is-visible');
    message.textContent = '';
  }

  function showValidation(text) {
    input.classList.add('is-invalid');
    message.textContent = text;
    message.hidden = false;
    message.classList.add('is-visible');
    input.focus();
  }

  function validate() {

    clearValidation();

    const email = input.value.trim();

    if (email === '') {
      showValidation('We just need your email address.');
      return false;
    }

    if (!input.checkValidity()) {
      showValidation('Please enter a valid email address.');
      return false;
    }

    return true;
  }

  button.addEventListener('click', () => {

    if (!validate()) return;

    form.requestSubmit();

  });

  input.addEventListener('keydown', (event) => {

    if (event.key === 'Enter') {

      event.preventDefault();

      if (!validate()) return;

      form.requestSubmit();

    }

  });

  input.addEventListener('input', clearValidation);

});